export default {"src":"/_next/static/media/icon-pass.42e2ed0a.svg","height":24,"width":24};